var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageNextDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 7",
    d: "M10.5 7.86602C11.1667 7.48112 11.1667 6.51887 10.5 6.13397L1.5 0.937817C0.833331 0.552917 -2.25055e-06 1.03404 -2.2842e-06 1.80384L-2.73846e-06 12.1962C-2.77211e-06 12.966 0.833331 13.4471 1.5 13.0622L10.5 7.86602Z",
    fill: "#8A8694"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNextDisable);
export default __webpack_public_path__ + "static/media/PageNextDisable.a30d8ff44419999b0fb53ae527c2cf96.svg";
export { ForwardRef as ReactComponent };